import React from "react";
import AttorneyInformationBase from "../../../../features/bonds/shared/components/AttorneyInformationBase";
import { HISTORIC_ATTORNEY_INFO_CONFIG } from "../historicAttorneyConfig";
import { HISTORIC_DATA_UPDATE_ERRORS } from "./historicCreationSharedPropTypes";

const ProbateHistoricAttorneyInformation = ({ data, updateData, errors }) => (
  <AttorneyInformationBase
    cfg={HISTORIC_ATTORNEY_INFO_CONFIG.probate}
    data={data}
    updateData={updateData}
    errors={errors}
    isGuest={false}
  />
);

ProbateHistoricAttorneyInformation.propTypes = HISTORIC_DATA_UPDATE_ERRORS;

export default ProbateHistoricAttorneyInformation;
